import { up } from 'up-fetch'

export * from './upfetch-client.tsx'
export * from './upfetch-server.ts'
export { isJsonifiable, isResponseError, isValidationError } from 'up-fetch'
export const upfetch = up(fetch, () => ({
  baseUrl: process.env.NEXT_PUBLIC_API_URL,
  headers: {
    Accept: 'application/json',
    'App-source': process.env.NEXT_PUBLIC_SOURCE,
  },
}))
